export const URLConstants = {
    
//    BASE_URL: 'http://localhost:8080',
    BASE_URL: 'http://patientportalapi-env.eba-cmxqzmqm.us-west-2.elasticbeanstalk.com',
    // 
};